import React, { useState } from "react";
import { ITicketField } from "../../models/ticket_fields.ts";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface TicketFieldSelectProps {
  label: string;
  ticketFields: ITicketField[];
  onSelectedTicketFieldValuesChange: (selectedValues: string[]) => void;
}

export const TicketFieldSelect: React.FC<TicketFieldSelectProps> = ({
  label,
  ticketFields,
  onSelectedTicketFieldValuesChange: onSelectedTicketFieldValuesChange,
}) => {
  const [selectedTicketFieldValues, setSelectedTicketFieldValues] =
    useState<string[]>();
  if (ticketFields && ticketFields.length > 0) {
    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          value={selectedTicketFieldValues || []}
          onChange={(event) => {
            const selectedValues = event.target.value as string[];
            setSelectedTicketFieldValues(selectedValues);
            onSelectedTicketFieldValuesChange(selectedValues);
          }}
          label={label}
        >
          {ticketFields.length === 0 ? (
            <MenuItem disabled>No options available</MenuItem>
          ) : (
            ticketFields.flatMap(
              (field) =>
                field.custom_field_options?.map((option) => (
                  <MenuItem key={option.id} value={option.value}>
                    {option.name}
                  </MenuItem>
                )) || [],
            )
          )}
        </Select>
      </FormControl>
    );
  }
};
